import type { CartItemDTO, ShoppingCartDTO } from '@t/api.types';

export const COUPON_CATEGORY = 'coupon';

export const isCouponItem = (item: CartItemDTO): boolean => item.category === COUPON_CATEGORY;

export const deriveAppliedCoupon = (cart: ShoppingCartDTO | null | undefined): CartItemDTO | null =>
  cart?.cartItem?.find(isCouponItem) ?? null;

export const getCouponDisplayName = (item: CartItemDTO): string => item.name ?? item.productOffering?.name ?? '';

/** Cart items excluding coupon lines (coupons are not plans). */
export const getNonCouponItems = (cart: ShoppingCartDTO | null | undefined): CartItemDTO[] =>
  (cart?.cartItem ?? []).filter((item) => !isCouponItem(item));
